<div class="search-container is-flex" role="menu" *ngIf="searchInput?.length || (this.locationResults?.length > 0 || this.listingResults?.length > 0 || this.mlsMatchResults?.length > 0) || recentSearches?.length ">
  <div class="recent-title is-flex" *ngIf="!searchInput.length">
    <span translate="recentResults.title.recentSearches"></span>
  </div>
  <div class="results" #resultListRef>
    <div *ngIf="!(this.locationResults.length > 0 || this.listingResults.length > 0 || this.mlsMatchResults.length > 0) && searchInput.length > 0" class="no-results">
      <ng-container *ngIf="!isSearchingForResults">
        <p class="entry">{{ 'searchResults.noResults' | translate }} <strong>{{ searchInput }}</strong></p>
        <p translate="searchResults.titleSuggest"></p>
        <ul>
          <li translate="searchResults.checkSpelling"></li>
          <li translate="searchResults.checkAddress"></li>
          <li translate="searchResults.broadenSearch"></li>
        </ul>
      </ng-container>
      <p class="entry" *ngIf="isSearchingForResults" translate="searchResults.searchingFor" [translateParams]="{name: searchInput}"></p>
    </div>
    <ng-container *ngIf="searchInput.length === 0">
      <div *ngFor="let search of recentSearches; trackBy: trackBy" class="result" tabindex="0" role="menuitem" (click)="selectResult.emit(search)" (keydown.enter)="selectResult.emit(search)" (blur)="onBlur.emit()" [attr.data-value]="search">{{search.text}}</div>
    </ng-container>
    <ng-container *ngIf="this.locationResults.length > 0 || this.listingResults.length > 0 || this.mlsMatchResults.length > 0">
      <section class="mls-match-results" *ngIf="mlsMatchResults.length">
        <div class="result-section-header">{{ 'details.mls-num' | translate }} {{searchInput}}</div>
        <app-mls-result *ngFor="let match of mlsMatchResults; trackBy: trackBy" [result]="match" (selectResult)="selectResult.emit($event)" (onBlur)="onBlur.emit()" (favouriteClick)="favouriteClick.emit($event)"></app-mls-result>
      </section>
      <section class="location-results" *ngIf="locationResults.length">
        <div class="result-section-header">Suggested Locations</div>
        <div *ngFor="let location of locationResults; trackBy: trackBy" class="result" tabindex="0" role="menuitem" (click)="selectResult.emit(location)" (keydown.enter)="selectResult.emit(location)" (blur)="onBlur.emit()" [attr.data-value]="location">{{location.text}}</div>
      </section>
      <section class="listing-results" *ngIf="listingResults.length">
        <div class="result-section-header">Listings</div>
        <div *ngFor="let listing of listingResults; trackBy: trackBy" class="result" tabindex="0" role="menuitem" (click)="selectResult.emit(listing.text)" (keydown.enter)="selectResult.emit(listing.text)" (blur)="onBlur.emit()" [attr.data-value]="listing">{{listing.text}}</div>
      </section >
    </ng-container>
  </div>
  <div class="btn-group is-flex" role="group" aria-label="" *ngIf="showButtons">
    <button class="btn" (click)="onCenterAtMyLocation()">
      <i class="my-location-ic material-icons md-18 has-pos-abs">my_location</i>
      {{ 'recentResults.actions.nearMe' | translate }}
    </button>
    <button (click)="onSavedSearchesClick($event)" class="btn" translate="recentResults.actions.savedSearches"></button>
  </div>
</div>
